import * as React from 'react';



export default class City extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" >
            <g fill="none" fillRule="evenodd">
                <path fill="#53A9DE" d="M11.812 14.488h1.28V5.306h-1.28z"/>
                <g stroke="" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6.846 1.5L2.5 4.654v9.833h4.346zM13.193 14.487V5.654L6.846 3.5v10.987h2.178v-2.146h2.08v2.146z"/>
                </g>
                <path stroke="" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".75" d="M3.96 5.836v.58M5.402 5.836v.58M3.96 7.836v.58M5.402 7.836v.58M3.96 9.836v.58M5.402 9.836v.58M3.96 11.836v.58M5.402 11.836v.58M8.916 6.236v.58M11.078 6.236v.58M8.916 8.236v.58M11.078 8.236v.58M8.916 10.236v.58M11.078 10.236v.58"/>
            </g>
        </svg>
    )
  }
}
